import './_RemoveTokenButton-a0d2969b.css';

var classes = {"TokenButton":"prc-Token-TokenButton-F4Y8h"};

export { classes as default };
